/* PW v60 globals: comet menu hover, Cash and Rusty on the newsletter box, staff ID badges.
   v66 (6 Oct): the dogs on the newsletter box no longer bob or hop. They sit still and play their real animated loops
   (Rusty grin, Cash sus: green-screen MP4s keyed live in WebGL, same assets as the corner peeks). Speech bubbles stay. */
(function(){
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 0C13 8 16 11 24 12C16 13 13 16 12 24C11 16 8 13 0 12C8 11 11 8 12 0Z"/></svg>';
  var CDN = 'https://cdn.shopify.com/s/files/1/0888/1628/8064/files/';
  var LOOPS = { m1: CDN + 'pwg-rusty-grin-loop.mp4', m2: CDN + 'pwg-cash-sus-loop.mp4' };
  function comet(){
    var ul = document.querySelector('.header__inline-menu .list-menu--inline');
    if(!ul || ul.querySelector('.pw-comet')) return;
    var c = document.createElement('span'); c.className = 'pw-comet'; c.innerHTML = '<i></i>' + STAR; ul.appendChild(c);
    var star = c.querySelector('svg'), spin = 0, lastX = null;
    var items = [].slice.call(ul.querySelectorAll(':scope > li'));
    function target(li){ return li.querySelector('.header__menu-item span') || li.querySelector('.header__menu-item') || li; }
    function moveTo(li, rest){
      var t = target(li); if(!t) return;
      var u = ul.getBoundingClientRect(), r = t.getBoundingClientRect();
      var x = r.left - u.left, w = r.width;
      c.setAttribute('data-dir', lastX !== null && x < lastX ? 'l' : 'r');
      lastX = x;
      c.style.left = x + 'px'; c.style.width = w + 'px'; c.style.top = (r.bottom - u.top + 4) + 'px';
      spin += 90; star.style.transform = 'rotate(' + spin + 'deg)';
      c.classList.toggle('is-rest', !!rest); c.classList.add('is-on');
    }
    var active = items.filter(function(li){ return li.querySelector('[aria-current="page"]'); })[0] || null;
    function rest(){ if(active){ moveTo(active, true); } else { c.classList.remove('is-on'); lastX = null; } }
    items.forEach(function(li){
      li.addEventListener('mouseenter', function(){ moveTo(li, false); });
      li.addEventListener('focusin', function(){ moveTo(li, false); });
    });
    ul.addEventListener('mouseleave', rest);
    window.addEventListener('resize', function(){ if(active) rest(); });
    if(active) setTimeout(rest, 300);
  }
  /* green-screen keyer, same maths as pw-cast.js */
  var VS='attribute vec2 p;varying vec2 u;void main(){u=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
  var FS='precision mediump float;varying vec2 u;uniform sampler2D t;void main(){vec4 c=texture2D(t,u);float m=max(c.r,c.b);float k=c.g-m;float a=1.-smoothstep(.10,.28,k);vec3 col=c.rgb;col.g=min(col.g,m+.04);gl_FragColor=vec4(col*a,a);}';
  function keyer(canvas){
    var g=null; try{ g=canvas.getContext('webgl',{premultipliedAlpha:true,alpha:true}); }catch(e){}
    if(!g) return null;
    function sh(tp,src){ var o=g.createShader(tp); g.shaderSource(o,src); g.compileShader(o); return o; }
    var pr=g.createProgram(); g.attachShader(pr,sh(g.VERTEX_SHADER,VS)); g.attachShader(pr,sh(g.FRAGMENT_SHADER,FS)); g.linkProgram(pr); g.useProgram(pr);
    var b=g.createBuffer(); g.bindBuffer(g.ARRAY_BUFFER,b); g.bufferData(g.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),g.STATIC_DRAW);
    var l=g.getAttribLocation(pr,'p'); g.enableVertexAttribArray(l); g.vertexAttribPointer(l,2,g.FLOAT,false,0,0);
    var tx=g.createTexture(); g.bindTexture(g.TEXTURE_2D,tx);
    [g.TEXTURE_WRAP_S,g.TEXTURE_WRAP_T].forEach(function(w){ g.texParameteri(g.TEXTURE_2D,w,g.CLAMP_TO_EDGE); });
    g.texParameteri(g.TEXTURE_2D,g.TEXTURE_MIN_FILTER,g.LINEAR); g.texParameteri(g.TEXTURE_2D,g.TEXTURE_MAG_FILTER,g.LINEAR);
    return function(src){ g.viewport(0,0,canvas.width,canvas.height); g.clearColor(0,0,0,0); g.clear(g.COLOR_BUFFER_BIT); try{ g.texImage2D(g.TEXTURE_2D,0,g.RGBA,g.RGBA,g.UNSIGNED_BYTE,src); }catch(e){ return false; } g.drawArrays(g.TRIANGLE_STRIP,0,4); return true; };
  }
  function liveLoop(img, url){
    if(RM || !url || img.dataset.pwLoop) return;
    img.dataset.pwLoop = '1';
    var cv = document.createElement('canvas'); cv.width = 600; cv.height = 800;
    var draw = keyer(cv); if(!draw) return;
    cv.className = img.className.replace('is-ready','') + ' pwb-masc--live'; cv.setAttribute('aria-hidden','true');
    var v = document.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline',''); v.setAttribute('muted',''); v.crossOrigin = 'anonymous'; v.preload = 'auto'; v.src = url;
    var shown = false, raf = 0, vis = true;
    function tick(){ if(v.readyState >= 2 && vis){ if(draw(v) && !shown){ shown = true; img.parentNode.insertBefore(cv, img.nextSibling); cv.classList.add('is-ready'); img.style.visibility = 'hidden'; } } raf = requestAnimationFrame(tick); }
    new IntersectionObserver(function(es){ vis = es[0].isIntersecting; if(vis){ var p = v.play(); if(p && p.catch) p.catch(function(){}); } else { v.pause(); } }, { rootMargin: '200px 0px' }).observe(img.closest('.pwb-join') || img);
    raf = requestAnimationFrame(tick);
  }
  function pack(){
    var perch = document.querySelector('.pwb-perch'); if(!perch) return;
    var join = perch.closest('.pwb-join');
    var rusty = perch.querySelector('.m1'), cash = perch.querySelector('.m2');
    var b1 = join.querySelector('.pwb-bub.b1'), b2 = join.querySelector('.pwb-bub.b2');
    var input = join.querySelector('input[type="email"]');
    var bt = {};
    function say(b, text, ms){ if(!b) return; b.textContent = text; b.classList.add('is-on'); clearTimeout(bt[b.className]); bt[b.className] = setTimeout(function(){ b.classList.remove('is-on'); }, ms || 3200); }
    function pick(a){ return a[Math.floor(Math.random()*a.length)]; }
    var RL = ['Hi! Hi! Hi!','Did you bring snacks?','I approve of you.','Best day ever.'], CL = ['I handle the money.','Not now. Counting.','Do not touch the ears.','Three percent. Final offer.'];
    new IntersectionObserver(function(es, o){
      if(!es[0].isIntersecting) return; o.disconnect();
      perch.classList.add('is-up');
      if(join.querySelector('.pwb-ok')){ setTimeout(function(){ say(b1, 'Best day ever.'); say(b2, 'Fine. Welcome.'); }, 900); }
    }, { threshold: .35 }).observe(join);
    /* swap each keyed still for its live loop once the still is ready */
    [rusty, cash].forEach(function(img){
      if(!img) return;
      var url = LOOPS[img.classList.contains('m1') ? 'm1' : 'm2'];
      if(img.classList.contains('is-ready')) liveLoop(img, url);
      else new MutationObserver(function(ms, o){ if(img.classList.contains('is-ready')){ o.disconnect(); liveLoop(img, url); } }).observe(img, { attributes: true, attributeFilter: ['class'] });
    });
    if(input){
      input.addEventListener('focus', function(){ say(b1, 'Ooh. A new friend.'); setTimeout(function(){ say(b2, 'Spell it right.'); }, 900); });
      var f = input.closest('form'); if(f) f.addEventListener('submit', function(){ say(b1, 'Yesss.'); });
    }
    perch.style.pointerEvents = 'auto';
    perch.addEventListener('click', function(e){ var t = e.target.closest('.pwb-masc'); if(!t) return; var isCash = t.classList.contains('m2'); say(isCash ? b2 : b1, pick(isCash ? CL : RL)); });
    [].forEach.call(document.querySelectorAll('.pwb-id[data-dog]'), function(card){
      var isCash = card.getAttribute('data-dog') === 'cash';
      card.addEventListener('mouseenter', function(){ say(isCash ? b2 : b1, pick(isCash ? CL : RL)); });
    });
    var ids = document.querySelector('.pwb-ids');
    if(ids){ new IntersectionObserver(function(es, o){ if(es[0].isIntersecting){ ids.classList.add('is-in'); o.disconnect(); } }, { threshold: .4 }).observe(ids); }
  }
  function init(){ comet(); pack(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
